<template>
  <div class="filter-group" v-if="filterGroup && filterGroup.tags.length > 0">
    <div class="filter-group-label">
      <span :class="{ 'lower-text': isReadOnly }" class="label-text">{{ filterGroup.label }}:</span>
    </div>

    <div class="filter-tags" >
      <div  v-for="tag in filterGroup.tags"
            :key="tag.id"
            class="filter-tag"
            :class="{ 'filter-display': isReadOnly }" >
        <span class="tag-text">{{ tag.label }}</span>
        <component  v-if="tag.icon"
                    :is="tag.icon"
                    :size="12"
                    class="tag-icon" />
        <X  :size="8"
            class="tag-remove"
            v-if="!isReadOnly"
            @click="$emit('remove-tag', { groupKey: filterGroup.key, tag })" />
      </div>
    </div>

    <div v-if="filterGroup.divider" class="filter-divider"></div>
  </div>
</template>

<script>
import { X } from 'lucide-vue-next';

export default {
  name: 'FilterInfo',

  components: { X },

  props: {
    filterGroup: { type: Object, required: true },
    isReadOnly: { type: Boolean, default: false }
  },

  emits: ['remove-tag']
};
</script>

<style lang="scss" scoped>
.filter-group {
  display: flex;
  align-items: center;
  gap: 24px;
}

.filter-group-label {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 50px;
}

.lower-text {
  text-transform: none !important;
  text-align: right;
}
.label-text {
  font-size: var(--font-12);
  min-width: 5rem;
  color: var(--bs-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}
.filter-display {
  border: none !important;
  background: unset !important;
  padding: 0;

  [data-bs-theme="dark"] & {
    border: none !important;
    background: unset !important;
  }
}

.filter-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: var(--custom-black-05);
  border: 1px solid var(--custom-black-20);
  border-radius: var(--radius-xs);
  transition: all 0.15s;
  &:hover {
    background: var(--custom-black-20);
  }

  [data-bs-theme="dark"] & {
    background: var(--custom-white-10);
    border-color: var(--custom-white-20);
    &:hover {
      background: var(--custom-white-20);
    }
  }
}

.tag-text {
  font-size: var(--font-10);
  font-weight: 300;
  color: var(--bs-body-color);
}

.tag-icon {
  flex-shrink: 0;
  color: var(--bs-secondary-color);
}

.tag-remove {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--bs-body-color);
  transition: color 0.15s;

  &:hover {
    color: var(--bs-danger);
  }
}

.filter-divider {
  width: 1px;
  height: 20px;
  background: var(--bs-border-color);
  margin: 0 8px;
}
</style>
